import styles from './DownloadCars.module.scss';
import DownloadCar from './Car/DownloadCar';

const DownloadCars = ({ item }) => {
  // 调试：检查item数据

  // 安全检查：如果没有车辆数据，返回空组件
  if (!item?.cars || item.cars.length === 0) {
    return null;
  }

  return (
    <div className={styles.cars} data-aos="fade-up">
      {item.cars.map((car) => {
        return <DownloadCar key={car.id} car={car} />;
      })}
    </div>
  );
};

export default DownloadCars;
